import React from 'react';
import { ROUTES } from '../helpers/constants';

const NotFound = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 py-20">
      <img src="/not-found.png" alt="-" className="mb-8" />
      <h1 className="font-semibold text-3xl">Maaf, Halaman yang kamu cari tidak ditemukan</h1>
      <h2 className="text-base">
        Kembali ke{' '}
        <a href={ROUTES.home} className="text-[#0898C9]">
          <b>Beranda</b>
        </a>
        , atau gunakan kata kunci lain
      </h2>
    </div>
  );
};

export default NotFound;
